import cs from './locales/default/cs.json'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'cs',
  messages: {
    cs,
  }
}))
